import { ContextualInfoButton } from "@/components/buttons/ContextualInfoButton";
import { CustomTabs } from "@/components/tabs/CustomTabs";
import { Select } from "antd";
import { MetricKey } from "./charts/common/utils";
import { MetricOption } from "./utils/metrics";
interface SelectMetricOptionsProps {
  variant?: "select" | "tabs";
  metric: MetricKey;
  setMetric: (value: MetricKey) => void;
  metricOptions: MetricOption[];
  selectClassName?: string;
  tabsCompact?: boolean;
}
const SelectMetricOptions = ({
  variant = "select",
  metric,
  setMetric,
  metricOptions,
  selectClassName = "w-[200px]",
  tabsCompact = true
}: SelectMetricOptionsProps) => {
  const items = metricOptions.map(o => ({
    value: o.value,
    key: o.value,
    label: <span className="inline-flex items-center gap-1">
        <span>
          {o.label} ({o.unit})
        </span>
        <ContextualInfoButton id={"metrics"} />
      </span>
  }));
  return variant === "tabs" ? <CustomTabs compact={tabsCompact} activeKey={metric} onChange={k => setMetric(k as MetricKey)} items={items} data-sentry-element="CustomTabs" data-sentry-component="SelectMetricOptions" data-sentry-source-file="SelectMetricOptions.tsx" /> : <Select className={selectClassName} value={metric} onChange={v => setMetric(v as MetricKey)} options={items} data-sentry-element="Select" data-sentry-component="SelectMetricOptions" data-sentry-source-file="SelectMetricOptions.tsx" />;
};
export default SelectMetricOptions;